/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EvaluatePromptGuardrailRequestBody,
  EvaluatePromptGuardrailRequestBody$Outbound,
  EvaluatePromptGuardrailRequestBody$outboundSchema,
} from "../components/evaluatepromptguardrailrequestbody.js";

export type EvaluatePromptGuardrailSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type EvaluatePromptGuardrailSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type EvaluatePromptGuardrailSecurity = {
  option1?: EvaluatePromptGuardrailSecurityOption1 | undefined;
  option2?: EvaluatePromptGuardrailSecurityOption2 | undefined;
};

export type EvaluatePromptGuardrailRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  evaluatePromptGuardrailRequestBody: EvaluatePromptGuardrailRequestBody;
};

/** @internal */
export type EvaluatePromptGuardrailSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const EvaluatePromptGuardrailSecurityOption1$outboundSchema:
  z.ZodMiniType<
    EvaluatePromptGuardrailSecurityOption1$Outbound,
    EvaluatePromptGuardrailSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function evaluatePromptGuardrailSecurityOption1ToJSON(
  evaluatePromptGuardrailSecurityOption1:
    EvaluatePromptGuardrailSecurityOption1,
): string {
  return JSON.stringify(
    EvaluatePromptGuardrailSecurityOption1$outboundSchema.parse(
      evaluatePromptGuardrailSecurityOption1,
    ),
  );
}

/** @internal */
export type EvaluatePromptGuardrailSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const EvaluatePromptGuardrailSecurityOption2$outboundSchema:
  z.ZodMiniType<
    EvaluatePromptGuardrailSecurityOption2$Outbound,
    EvaluatePromptGuardrailSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function evaluatePromptGuardrailSecurityOption2ToJSON(
  evaluatePromptGuardrailSecurityOption2:
    EvaluatePromptGuardrailSecurityOption2,
): string {
  return JSON.stringify(
    EvaluatePromptGuardrailSecurityOption2$outboundSchema.parse(
      evaluatePromptGuardrailSecurityOption2,
    ),
  );
}

/** @internal */
export type EvaluatePromptGuardrailSecurity$Outbound = {
  Option1?: EvaluatePromptGuardrailSecurityOption1$Outbound | undefined;
  Option2?: EvaluatePromptGuardrailSecurityOption2$Outbound | undefined;
};

/** @internal */
export const EvaluatePromptGuardrailSecurity$outboundSchema: z.ZodMiniType<
  EvaluatePromptGuardrailSecurity$Outbound,
  EvaluatePromptGuardrailSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => EvaluatePromptGuardrailSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => EvaluatePromptGuardrailSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function evaluatePromptGuardrailSecurityToJSON(
  evaluatePromptGuardrailSecurity: EvaluatePromptGuardrailSecurity,
): string {
  return JSON.stringify(
    EvaluatePromptGuardrailSecurity$outboundSchema.parse(
      evaluatePromptGuardrailSecurity,
    ),
  );
}

/** @internal */
export type EvaluatePromptGuardrailRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  EvaluatePromptGuardrailRequestBody:
    EvaluatePromptGuardrailRequestBody$Outbound;
};

/** @internal */
export const EvaluatePromptGuardrailRequest$outboundSchema: z.ZodMiniType<
  EvaluatePromptGuardrailRequest$Outbound,
  EvaluatePromptGuardrailRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    evaluatePromptGuardrailRequestBody:
      EvaluatePromptGuardrailRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      evaluatePromptGuardrailRequestBody: "EvaluatePromptGuardrailRequestBody",
    });
  }),
);

export function evaluatePromptGuardrailRequestToJSON(
  evaluatePromptGuardrailRequest: EvaluatePromptGuardrailRequest,
): string {
  return JSON.stringify(
    EvaluatePromptGuardrailRequest$outboundSchema.parse(
      evaluatePromptGuardrailRequest,
    ),
  );
}
